import { useState } from 'react';
import { useNavigate } from "@tanstack/react-location";
import { UserDemographics } from "../../model/App/Data/User";
import * as App from "../../model/App";
import {
    Alert,
    TextInput,
    PasswordInput,
    LoadingOverlay,
    Anchor,
    Paper,
    Title,
    Text,
    Container,
    Group,
    Button,
  } from '@mantine/core';
  
export default function SignupScreen() {
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [passwordConfirm, setPasswordConfirm] = useState<string>("");
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isLoadingAccountSetup, setIsLoadingAccountSetup] = useState<boolean>(false);
    const navigate = useNavigate();

    // Perform validation for form controls...
    const doValidation = (): boolean => {
        // Make sure passwords match...
        if (password !== passwordConfirm) {
            setErrorMessage("Passwords do not match");
            return false;
        }

        // Email/password are mostly handled by firebase...

        setErrorMessage("");
        return true;
    }

    // "Signup" button...
    const onSignupPress = (event: any) => {
        // Validate form...
        if (!doValidation()) { return; }

        // Create a user...
        setIsLoading(true);
        setIsLoadingAccountSetup(true);
        setErrorMessage("");

        const userDemographics = new UserDemographics("", "", email);
        App.Firebase.Auth.createAppUserWithEmailAndPassword(userDemographics, email, password)
            .then(() => {
                setIsLoading(false);
                setErrorMessage("");
                navigate({ to: "/" });
                window.location.reload();       // TODO: This is a workaround
            }, (error: any) => {
                console.log(error);
                setIsLoading(false);
                setIsLoadingAccountSetup(false);
                setErrorMessage(error.message);
            });
    }

    return (
      <Container size={420} my={40}>
        <Title align="center" sx={(theme) => ({ fontFamily: `Greycliff CF, ${theme.fontFamily}`, fontWeight: 900 })}>
          <Text align="center" color="red" weight="bold" style={{ fontSize: "108pt", lineHeight: 1 }}>æ</Text>
          <Text align="center" color="red" weight="bold" style={{ fontSize: "24pt" }}>Aarón Estrada Legal</Text>
          <Text color="red">Patent & Trademark Docket</Text>
        </Title>
  
        <LoadingOverlay visible={isLoading || isLoadingAccountSetup} />
        <Paper withBorder shadow="md" p={30} mt={30} radius="md">
            <TextInput label="Email" placeholder="aaron@aestradalegal.com" required value={email} onChange={(event) => { setEmail(event.target.value); }}  />
            <PasswordInput label="Password" placeholder="Password" required mt="md" value={password} 
                onChange={(event) => { setPassword(event.target.value); }} 
            />
            <PasswordInput label="Password (confirm)" placeholder="Password (confirm)" required mt="md" value={passwordConfirm} 
                onChange={(event) => { setPasswordConfirm(event.target.value); }} 
                onKeyPress={(event) => {  if (event.key === "Enter" || event.charCode === 13) { onSignupPress(null); }  }}
            />

            <Group position="apart" mt="md">
                <Anchor<'a'> onClick={() => navigate({ to: "/login" })} href="#" size="sm">
                Back to login
                </Anchor>
            </Group>
            <Button fullWidth mt="xl" onClick={onSignupPress}>
                Sign up
            </Button>

            {errorMessage ? <Alert color="red" title="Error" mt="md">{errorMessage}</Alert> : null}
        </Paper>
      </Container>
    );
}